module.exports = __webpack_public_path__ + "static/media/SWSCRC1-29.6f836bee.mp3";